import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Modal from "../../legacy/Modal";
import CloseButton from "../../library/Button";
import { ModalBody } from "../styles/share-modal-styles";
import Saving from "../../shared/loaders/Saving";
import ForwardedCvSend from "../../../apiResources/ForwardedCvSend";
import EmailsSentView from "./EmailsSentView";
import SendEmailsView from "./SendEmailsView";
import trackEvent from "../../shared/ga/trackEvent";

// disabling prop-types because this is a typescript component.
// declaring prop-types + ts interfaces is unneccesary duplication
/* eslint-disable react/prop-types */

export interface ShareModalProps {
  showModalFn: (show: boolean) => void;
  emailDomains: string[];
  candidateId: number;
  applicationId: number;
  candidateFullName: string;
}

const ShareModal: React.FC<ShareModalProps> = ({
  showModalFn,
  emailDomains,
  applicationId,
  candidateId,
  candidateFullName,
}) => {
  const [emailsSent, setEmailsSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [emailAddresses, setEmailAddresses] = useState<string[]>([]);
  const [errors, setErrors] = useState({});

  const handleSend = async () => {
    setIsLoading(true);

    const forwardedCvSend = new ForwardedCvSend({
      emailAddresses,
      applicationId,
      candidateId,
    });

    const success = await forwardedCvSend.save();

    if (success) {
      trackEvent("ForwardedCvs", "Create");
    }

    setEmailAddresses(forwardedCvSend.emailAddresses);
    setEmailsSent(success);
    setErrors(forwardedCvSend.errors);
    setIsLoading(false);
  };

  const modalTitle = emailsSent
    ? `Your secure link to ${candidateFullName} has been sent to...`
    : `Share ${candidateFullName}'s CV with the following Hiring Managers...`;

  return (
    <Modal title={modalTitle} dataTestId="share-modal">
      <CloseButton
        icon
        id="close-modal-button"
        name="close modal"
        type="button"
        aria-label="Close Modal"
        onClick={() => showModalFn(false)}
      >
        <FontAwesomeIcon icon={faTimes} />
      </CloseButton>
      <ModalBody>
        {isLoading ? (
          <Saving white noText />
        ) : (
          <>
            {emailsSent ? (
              <EmailsSentView
                showModalFn={showModalFn}
                emailAddresses={emailAddresses}
              />
            ) : (
              <SendEmailsView
                emailDomains={emailDomains}
                emailAddresses={emailAddresses}
                handleSend={handleSend}
                setEmailAddresses={setEmailAddresses}
                errors={errors}
                resetErrors={() => setErrors({})}
              />
            )}
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ShareModal;
